import {
  Select,
  SelectContent,
  SelectGroup,
  SelectTrigger,
  SelectItem,
} from '@e2n/ui';
import {
  getWeekdayOccurrenceStringFromTerminWeekdayOccurrence,
  TerminWeekdayOccurrence,
  TerminWiederholungsIntervall,
} from '@/domain/termine/shared/types';
import { isTerminRepetitionIntervall } from '@/domain/termine/shared/utils/individuelleWiederholungenHelper';
import { UpdateTermineFormProps } from '@/domain/termine/features/UpdateTermin/shared';

interface WeekdayOccurenceProps extends UpdateTermineFormProps {
  value: TerminWeekdayOccurrence | undefined;
  onChange: (value: TerminWeekdayOccurrence) => void;
}

export default function WeekdayOccurrence({
  value,
  onChange,
  form,
}: WeekdayOccurenceProps) {
  return (
    <form.Subscribe
      selector={(state) =>
        [state.values.datum, state.values.wiederholungsIntervall] as const
      }>
      {([date, selectedRepetition]) => {
        const repetition = isTerminRepetitionIntervall(selectedRepetition)
          ? selectedRepetition
          : TerminWiederholungsIntervall.WOCHE;

        return (
          <div className="pb-3 h-10">
            <Select value={value ?? undefined} onValueChange={onChange}>
              <SelectTrigger className="border-neutrals-300 w-full">
                <div>
                  {value
                    ? getWeekdayOccurrenceStringFromTerminWeekdayOccurrence(
                        value,
                        date,
                        repetition,
                      )
                    : ''}
                </div>
              </SelectTrigger>
              <SelectContent className="border-none overflow-visible">
                <SelectGroup className="p-1">
                  {Object.values(TerminWeekdayOccurrence).map((enumValue) => (
                    <SelectItem
                      className="p-2"
                      key={enumValue}
                      value={enumValue}>
                      {getWeekdayOccurrenceStringFromTerminWeekdayOccurrence(
                        enumValue,
                        date,
                        repetition,
                      )}
                    </SelectItem>
                  ))}
                </SelectGroup>
              </SelectContent>
            </Select>
          </div>
        );
      }}
    </form.Subscribe>
  );
}
